var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-view"},[_c('main-section-dashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }